export type OpportunityStatus = 'Potential' | 'Committed' | 'Completed' | 'Withdrawn';
export type ActionStatus = 'To Do' | 'In Progress' | 'Done' | 'Blocked' | 'Withdrawn';
export type SourceType = 'aiAgent' | 'human';

export interface Opportunity {
  id: string;
  opportunityDescription: string;
  source: string;
  sourceType: SourceType;
  createdDate: string;
  updatedDate: string;
  priority: 'High' | 'Medium' | 'Low';
  status: OpportunityStatus;
}

export interface ClientAction {
  id: string;
  financialAssistantName: string;
  action: string;
  opportunityId: string | null;
  source: string;
  sourceType: SourceType;
  createdDate: string;
  plannedDate: string;
  deadline: string;
  status: ActionStatus;
}

export interface ActionsState {
  opportunities: Opportunity[];
  actions: ClientAction[];
}
